<template>
  <div style="width: 100%; display: flex; flex-direction: column; justify-content: center">
    <div style="width: 100%; display: flex; justify-content: center">
      <div style="width: 100%; max-width: 250px; display: flex; flex-direction: column">
        <div class="infotext text-center mb-4">
          <p v-html="getInfoText"></p>
        </div>
        <div class="mb-4">
          <v-form ref="contactform" v-model="isFormValid">
            <div class="mb-4">
              <v-text-field
                v-model="senderName"
                class="messagearea smalltext"
                type="text"
                outlined
                hide-details
                :label="languageOption === 'SWEDISH' ? 'Namn' : 'Name'"
              ></v-text-field>
            </div>
            <div>
              <v-text-field
                validate-on-blur
                required
                :rules="emailRules"
                v-model="senderEmail"
                class="messagearea smalltext"
                type="email"
                outlined
                label="* Email"
              ></v-text-field>
            </div>
            <div class="mb-4">
              <v-text-field
                v-model="senderPhone"
                class="messagearea smalltext"
                type="text"
                outlined
                hide-details
                :label="languageOption === 'SWEDISH' ? 'Telefon' : 'Phone'"
              ></v-text-field>
            </div>
            <div>
              <v-textarea
                required
                :rules="requiredRules"
                v-model="senderMessage"
                class="messagearea"
                outlined
                :label="languageOption === 'SWEDISH' ? '*Meddelande' : '* Message'"
              ></v-textarea>
            </div>
          </v-form>
        </div>
        <div class="mb-4" style="display: flex; justify-content: space-between">
          <v-btn class="smallbutton" @mousedown="$router.go(-1)" :loading="sending" :disabled="sending">
            <span v-if="languageOption === 'SWEDISH'">Tillbaka</span>
            <span v-else>Back</span></v-btn
          >
          <v-btn class="smallbutton ml-3" @mousedown="save()" :loading="sending" :disabled="!isFormValid">
            <span v-if="languageOption === 'SWEDISH'">Skicka</span>
            <span v-else>Send</span>
            <template v-slot:loader>
              <span v-if="languageOption === 'SWEDISH'">Skickar...</span>
              <span v-else>Sending...</span>
            </template>
          </v-btn>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { HTTP } from "@/plugins/backendAPI";
import { mapGetters } from "vuex";

const emailRegex = /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/;

export default {
  props: ["qrstring", "workspaceid", "qrworkspaceid"],
  data() {
    return {
      sending: false,

      senderName: null,
      senderEmail: null,
      senderPhone: null,
      senderMessage: null,

      requiredRules: [(v) => !!v || "Field is required"],
      emailRequirementRegex: null,
      emailRequirementHint: "Email is in incorrect format",
      emailRules: [
        (v) => !!emailRegex.test(v) || "Email is in incorrect format",
        (v) => !!this.testEmailRequirementRegex(v) || this.emailRequirementHint,
      ],
      isFormValid: false,
    };
  },
  created() {
    this.$store.dispatch("setLoading", true);
    HTTP.get(`/mobil/get/email-Requirement${(!this.qrstring ? `?workspace-id=${this.workspaceid}&qr-workspace-id=${this.qrworkspaceid}` : `?qr-string=${this.qrstring}`)}`)
      .then((response) => {
        this.emailRequirementRegex = new RegExp("^$|null|" + response.data.emailRequirementRegex);
        if (response.data.emailRequirementHint !== null) {
          this.emailRequirementHint = response.data.emailRequirementHint;
        }
      })
      .finally(() => {
        this.$store.dispatch("setLoading", false);
      });
  },
  computed: {
    ...mapGetters(["loading"]),
    languageOption() {
      return this.$store.state.languageOption;
    },
    getInfoText() {
      return this.languageOption === "SWEDISH"
        ? "Fyll i formuläret så kontaktar vi dig så snart som möjligt"
        : "Fill out the form and we will<br/>contact you as soon as possible";
    },
  },

  methods: {
    testEmailRequirementRegex(email) {
      if (!this.emailRequirementRegex) {
        return true;
      }
      if (email !== null) {
        email = email.toLowerCase();
      }
      return !!this.emailRequirementRegex.test(email);
    },
    save() {
      this.$store.dispatch("setLoading", true);
      this.sending = true;
      HTTP.post("/mobil/sendform", {
        workspaceid: this.workspaceid,
        qrworkspaceid: this.qrworkspaceid,
        formType: "Contact request",
        name: this.senderName,
        email: this.senderEmail,
        phone: this.senderPhone,
        message: this.senderMessage,
      })
        .then(() => {
          this.sending = false;
          if (isNaN(this.$route.fullPath.split("/")[3])) {
            this.$router.push({ name: "LegacyMobileFormSentSuccess" });
          } else {
            this.$router.push({ name: "MobileFormSentSuccess" });
          }
        })
        .catch((e) => {
          this.sending = false;
          this.$store.dispatch("showError", e.response.data);
        })
        .finally(() => {
          this.$store.dispatch("setLoading", false);
        });
    },
  },
};
</script>

<style></style>
